import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-image">
          <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=400&fit=crop" alt="Restoran" />
          <div className="about-image-badge">15+ Yıl Deneyim</div>
        </div>
        
        <div className="about-content">
          <h2>Resume Çiğköfte Hakkında</h2>
          <p>
            Resume Çiğköfte, 15 yıldır Türk mutfağının en lezzetli ürünlerini sunmakta ve müşteri memnuniyetini ön planda tutmaktadır. Özgün tatımızla binlerce müşteri ailemizin parçası olmuştur.
          </p>
          <p>
            Geleneksel tarifler kullanarak, en taze malzemeleri seçip, her çiğköfte'yi özenle hazırlanıyor. Ailemizle yemek yemenin keyfi yaşayan müşterilerimiz, bizim en büyük referansımızdır.
          </p>
          
          <div className="about-features">
            <div className="feature">
              <div className="feature-icon">🌟</div>
              <div className="feature-text">
                <h4>Özgün Lezzet</h4>
                <p>Yalnızca Resume'de bulunan, geleneksel tarif</p>
              </div>
            </div>
            
            <div className="feature">
              <div className="feature-icon">⚡</div>
              <div className="feature-text">
                <h4>Hızlı Servis</h4>
                <p>30 dakikada teslim garantisi</p>
              </div>
            </div>
            
            <div className="feature">
              <div className="feature-icon">💰</div>
              <div className="feature-text">
                <h4>Uygun Fiyat</h4>
                <p>En iyi kalite, en adil fiyat</p>
              </div>
            </div>

            <div className="feature">
              <div className="feature-icon">✓</div>
              <div className="feature-text">
                <h4>Taze Malzeme</h4>
                <p>Her gün yeni ve kaliteli malzeme</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
